/**
 * Anonymous visitors have no session until replay (or another private surface).
 * Creates a guest session when needed and returns whether the viewer is a guest
 * (for replay entitlement toasts).
 */
export async function ensureSessionForReplay(
  isLoggedIn: boolean,
  isGuest: boolean,
  continueAsGuest: () => Promise<void>,
): Promise<boolean> {
  if (!isLoggedIn) {
    await continueAsGuest();
    return true;
  }
  return isGuest;
}
